import axios from 'axios';
import qs from 'qs'

// 引入状态管理
import store from '@/vuex/store'
import router from '@/router';
const CancelToken = axios.CancelToken;


// 登录请求方法
const loginreq = (method, url, params) => {
  return axios({
      method: method,
      url: url,
      timeout: 10000,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      data: params,
      traditional: true,

      transformRequest: [
        function(data) {
          let ret = ''
          for (let it in data) {
            ret +=
              encodeURIComponent(it) +
              '=' +
              encodeURIComponent(data[it]) +
              '&'
          }
          return ret
        }
      ]
    })
    .then(res => {
      if (res.errCode) {
        if (res.errCode >= 500) {
          return { ...res,
            msg: '服务器请求错误，请稍后再尝试'
          }
        }
      }

      // return res
     return res
    })
};




const getReq = ( url, params) => {

  return new Promise((resolve, reject) => {
   axios.get(url+'/'+params).then(res =>{
     resolve(res.data);
   })
   .catch(err => {
     reject(err.data)
   })

  });
};


const getReqObj = ( url, params) => {
  console.log(url)
  return new Promise((resolve, reject) => {
   axios({
     url,
     method: 'get',
     params,
     headers: {'Content-Type':'application/json', token:sessionStorage.getItem("token") || ''},
     paramsSerializer: function (params) {
     	return qs.stringify(params, { arrayFormat: 'indices'});
     }
   }).then(res =>{
     resolve(res.data);
   })
   .catch(err => {
     reject(err.data)
   })

  });
};

const reqObj = ( url, params) => {

  return new Promise((resolve, reject) => {
    axios.post(url, params,{headers: {'Content-Type':'application/json',token:sessionStorage.getItem("token") || ''}})
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data)
      })
  });
};

const reqObjGet = ( url, params) => {

  return new Promise((resolve, reject) => {
    axios.get(url, params,{headers: {'Content-Type':'application/json',token:sessionStorage.getItem("token") || ''}})
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data)
      })
  });
};







// 通用公用方法
const req = (method, url, params, upload) => {
  let data = method.toLocaleLowerCase() === 'get' ? 'params' : 'data';
  let contentType = 'application/x-www-form-urlencoded'
  if (upload) {
    contentType = 'multipart/form-data;charset=UTF-8'
  }
  return axios({
    method: method,
    url: url,
    headers: {
      'Content-Type': contentType,
       token:sessionStorage.getItem("token") || ''
    },
    [data]: params,
    cancelToken: new CancelToken(c => { //强行中断请求要用到的
      store.commit('setCancelRequest', c)
    }),
    paramsSerializer: params => {
      return qs.stringify(params)

    },
    traditional: true,
    transformRequest: [
      function(data) {
        if (!upload) {
          let ret = ''
          for (let it in data) {
            ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
          }
          return ret
        } else {
          return data
        }
      }
    ]
  }).then(res => {

    if (res.data.status == 2) {

      store.commit('setRe', true)
      store.commit('login', '')
      sessionStorage.setItem("userInfo", '');
      router.push({
        path: '/login'
      })
      return ''
    } else {
      store.commit('setRe', false)
    }

    if (res.errCode) {
      if (res.errCode >= 500) {
        return { ...res,
          msg: '服务器请求错误，请稍后再尝试'
        }
      }
    }

    return res.data
  })
};





// http response 拦截器

axios.interceptors.response.use(
  response => {

    return response;
  },
  error => {
    if (error.response) {

      return Promise.resolve({
        errCode: error.response.status
      }) // 可在组件内获取到服务器返回信
    }

  });
export {
  loginreq,
  req,
  reqObj,
  getReq,
  getReqObj,
  reqObjGet
}



// WEBPACK FOOTER //
// ./src/api/axiosFun.js